<script setup lang="ts">
import {RouterLink} from 'vue-router'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps({
  // @ts-ignore
  ...RouterLink.props,
})
</script>

<template>
  <RouterLink
      v-bind="$props"
      custom
      v-slot="{ href, navigate }"
      :to="props.to"
      @click.stop
  >
    <a
        v-bind="$attrs"
        :href="href"
        @click.stop="navigate"
    >
      <slot />
    </a>
  </RouterLink>
</template>